
(function ($) {
    $.fn.glossary = function () {
        return this.each(function () {
            var $container = $(this),
                $trigger = $container.find('.term'),
                term = $container.data('term'),
                link = $container.data('link'),
                definition = $container.data('explanation'),
                tip = $('<div class="glossary-tooltip"><div class="tip-content"><h2>' + term + '</h2>' + definition + '</div></div>').hide(),
                classname = '';



            function showTip(e) {
                if (e) {
                    e.preventDefault();
                }

                var $position = $container.position(),
                    $container_mid = $position.left + ($container.width()/2),
                    $parent = $container.closest('.glossaryHighlighter'),
                    $parent_mid = $parent.outerWidth()/2;

                if(Math.abs($parent_mid - $container_mid) > $parent.outerWidth()/5){
                    if($parent_mid - $container_mid < 0) {
                        classname = 'right';
                    } else {
                        classname = 'left';
                    }
                }
                $trigger.addClass('highlighted')
                tip.addClass(classname);
                $container.append('<div class="glossary-layout"></div>');
                $('.glossary-layout').on('click',hideTip);
                $container.append(tip.stop().fadeIn(300));
            }

            function hideTip(e) {
                if (e) {
                    e.preventDefault();
                }
                $trigger.removeClass('highlighted')
                tip.fadeOut(300, function () {
                    tip.remove();
                });
                $('.glossary-layout').remove();
            }

            $trigger.bind({
                click: showTip
            });
        });
    };
})(jQuery);